<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 12C3 9.20435 3 7.80653 3.45672 6.7039C4.06569 5.23373 5.23373 4.06569 6.7039 3.45672C7.80653 3 9.20435 3 12 3C14.7956 3 16.1935 3 17.2961 3.45672C18.7663 4.06569 19.9343 5.23373 20.5433 6.7039C21 7.80653 21 9.20435 21 12C21 14.7956 21 16.1935 20.5433 17.2961C19.9343 18.7663 18.7663 19.9343 17.2961 20.5433C16.1935 21 14.7956 21 12 21C9.20435 21 7.80653 21 6.7039 20.5433C5.23373 19.9343 4.06569 18.7663 3.45672 17.2961C3 16.1935 3 14.7956 3 12Z"
      fill="#EDEFF2"
    />
    <path
      d="M17.7097 8.29289C18.1003 8.68342 18.1003 9.31658 17.7097 9.7071L11.2071 16.2096C10.8166 16.6001 10.1834 16.6001 9.79289 16.2095L6.79289 13.2095C6.40237 12.819 6.40237 12.1858 6.7929 11.7953C7.18343 11.4047 7.81659 11.4048 8.20711 11.7953L10.5 14.0882L16.2955 8.29287C16.6861 7.90235 17.3192 7.90236 17.7097 8.29289Z"
      fill="#1F2026"
    />
  </svg>
</template>
